//
import WhFamilyModel from '@/models/Warehouse/WhFamily'
import WhItemModel from '@/models/Warehouse/WhItem'
import WhSubfamilyModel from '@/models/Warehouse/WhSubfamily'
import WhProductModel from '@/models/Warehouse/WhProduct'
import WhPackHeaders from '@/views/Warehouse/WhPack/WhPackHeaders'

//
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

//
export default {

  /**
   * 
   */
  create: [
    {
      type: 'section-field',
      flex: {
        xs12: true,
      },
      props: {
        class: 'caption',
        title: 'Producto relacionado',
      },
    },
    {
      name: 'wh_item_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'name',
        itemValue: 'wh_item_id',
        label: 'Producto',
        model: WhProductModel,
        noObject: true,
        rules: [RequiredRule],
      },
    },
    {
      name: 'item_quantity',
      type: 'float-field',
      props: {
        label: 'Cantidad',
        rules: [RequiredRule],
      },
    },
    {
      type: 'section-field',
      flex: {
        xs12: true,
      },
      props: {
        class: 'caption',
        title: 'Información del pack',
      },
    },
    {
      name: 'upc_codes',
      type: 'combobox',
      props: {
        chips: true,
        deletableChips: true,
        items: [],
        label: 'UPC',
        multiple: true,
        noDataText: 'Sin códigos UPC.',
      },
    },
    {
      name: 'internal_code',
      type: 'text-field',
      props: {
        label: 'Codigo interno',
        rules: [RequiredRule],
      },
    },
    {
      name: 'name',
      type: 'text-field',
      props: {
        label: 'Nombre',
        rules: [RequiredRule],
      },
    },
    {
      name: 'alias_name',
      type: 'text-field',
      props: {
        label: 'Alias',
        rules: [RequiredRule],
      },
    },
    {
      name: 'wh_family_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'family',
        itemValue: 'id',
        label: 'Familia',
        model: WhFamilyModel,
        paramSearch: 'family',
        noObject: true,
        rules: [RequiredRule],
      },
    },
    {
      name: 'wh_subfamily_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'subfamily',
        itemValue: 'id',
        label: 'Subfamilia',
        model: WhSubfamilyModel,
        paramSearch: 'subfamily',
        noObject: true,
        rules: [RequiredRule],
      },
      trigger: subfamily_trigger,
    },
    {
      name: 'cost_price',
      type: 'float-field',
      props: {
        label: 'Precio costo',
      },
      trigger(ctx) {
        ctx.value.branch_offices.forEach(branch => {
          branch.cost_price = ctx.value.cost_price
        })
      },
    },
    {
      name: 'sale_price',
      type: 'float-field',
      props: {
        label: 'Precio venta',
      },
      trigger(ctx) {
        ctx.value.branch_offices.forEach(branch => {
          branch.sale_price = ctx.value.sale_price
        })
      },
    },
    {
      name: 'branch_offices',
      type: 'table-field',
      flex: {
        'd-grid': true,
        xs12: true,
      },
      props: {
        noDataText: 'Sin sucursales.',
        headers: WhPackHeaders.detail,
        toolbarTitle: 'Sucursales',
      },
    },
    {
      name: 'warranty_days',
      type: 'float-field',
      props: {
        label: 'Dias de garantía',
        rules: [RequiredRule],
      },
    },
  ],

  /**
   * 
   */
  update: props => [
    {
      type: 'section-field',
      flex: {
        xs12: true,
      },
      props: {
        class: 'caption',
        title: 'Producto relacionado',
      },
    },
    {
      name: 'wh_item_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'wh_product_name',
        itemValue: 'id',
        label: 'Producto',
        model: WhItemModel,
        noAsync: true,
        noObject: true,
        readonly: true,
        rules: [RequiredRule],        
      },
    },
    {
      name: 'item_quantity',
      type: 'float-field',
      props: {
        label: 'Cantidad',
        rules: [RequiredRule],
      },
    },
    {
      type: 'section-field',
      flex: {
        xs12: true,
      },
      props: {
        class: 'caption',
        title: 'Información del pack',
      },
    },
    {
      name: 'upc_codes',
      type: 'combobox',
      props: {
        chips: true,
        deletableChips: true,
        items: props.upc_codes,
        label: 'UPC',
        multiple: true,
        noDataText: 'Sin códigos UPC.',
      },
    },
    {
      name: 'internal_code',
      type: 'text-field',
      props: {
        label: 'Codigo interno',
        rules: [RequiredRule],
      },
    },
    {
      name: 'name',
      type: 'text-field',
      props: {
        label: 'Nombre',
        rules: [RequiredRule],
      },
    },
    {
      name: 'alias_name',
      type: 'text-field',
      props: {
        label: 'Alias',
        rules: [RequiredRule],
      },
    },
    {
      name: 'wh_family_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'family',
        itemValue: 'id',
        label: 'Familia',
        model: WhFamilyModel,
        paramSearch: 'family',
        noObject: true,
      },
    },
    {
      name: 'wh_subfamily_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'subfamily',
        itemValue: 'id',
        label: 'Subfamilia',
        model: WhSubfamilyModel,
        paramSearch: 'subfamily',
        noObject: true,
        rules: [RequiredRule],
      },
      trigger: subfamily_trigger,
    },
    {
      name: 'cost_price',
      type: 'float-field',
      props: {
        label: 'Precio costo',
      },
      trigger(ctx) {
        ctx.value.branch_offices.forEach(branch => {
          branch.cost_price = ctx.value.cost_price
        })
      },
    },
    {
      name: 'sale_price',
      type: 'float-field',
      props: {
        label: 'Precio venta',
      },
      trigger(ctx) {
        ctx.value.branch_offices.forEach(branch => {
          branch.sale_price = ctx.value.sale_price
        })
      },
    },
    {
      name: 'branch_offices',
      type: 'table-field',
      flex: {
        'd-grid': true,
        xs12: true,
      },
      props: {
        noDataText: 'Sin sucursales.',
        headers: WhPackHeaders.detail,
        toolbarTitle: 'Sucursales',
      },
    },
    {
      name: 'warranty_days',
      type: 'float-field',
      props: {
        label: 'Dias de garantía',
        rules: [RequiredRule],
      },
    },
  ],
} 

/**
 * 
 */
function subfamily_trigger(ctx) {
  ctx.value.wh_family_id = ctx.getInput('wh_subfamily_id').getSelected().wh_family_id
}
